// extracted by mini-css-extract-plugin
module.exports = {"block":"Footer_block__3JmkC","grid":"Footer_grid__GCvR4","column":"Footer_column__J1RXt","org":"Footer_org__95NSL","sejfaLogo":"Footer_sejfaLogo__N9ISH"};